<div class="timeout-modal">
  <button type="button" class="close close-icon" aria-label="Close"
          (click)="modal.dismiss('Cross click')">
  </button>
  <div [class]="'modal-header'">
    <h3>
      <strong id="modal-title" *ngIf="content.title">{{content.title}}</strong>
    </h3>
  </div>
  <div [class]="'modal-body'" *ngIf="content && content.body">
    <div [innerHTML]="content.body"></div>
  </div>
  <div *ngIf="content" [class]="'modal-footer'">
    <button class="button ice-btn-default-red" *ngIf="content.primaryAction && !content.secondaryAction==true" type="submit"
            (click)="success()"
            (keydown)="onKeydownLastHandler($event)" >
      {{content.primaryAction}}</button>
    <button class="button ice-btn-default-red" *ngIf="content.primaryAction && !content.secondaryAction==false"
            type="submit"
            (click)="success()"   >
      {{content.primaryAction}}</button>

    <button class="button"
            *ngIf="content.secondaryAction"
            (click)="dismiss()"
            (keydown)="onKeydownLastHandler($event)">{{content.secondaryAction}}</button>
  </div>
</div>
